import React from 'react';
import SharedCards from '../../Shared/SharedCards/SharedCards';
import { whyData } from './data';

const Why=()=>{
    return(
        <>
        <SharedCards 
        title="Why you should join our awesome team"
        list={whyData}

        />
        </>
    )
};
export default Why ;